module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_06_1280_1280_vi-4c43d42f7e4f985fe29471dfc1b3c9f5.jpg";